<div class="sidenav-content">
    <div class="bcontainer2">
        <div class="main-content">
            <div class="spacer2"></div>

            <div class="containter">
                <!-- Header Section with Controls -->
                <div class="page-header">
                    <div class="header-top">
                        <div class="header-title-section">
                            <i class="fa fa-angle-left back-icon" aria-hidden="true" (click)="goBack()"
                                title="Go back"></i>
                            <div>
                                <h1 class="page-title">
                                    <i class="fa-solid fa-receipt title-icon"></i>
                                    Receipts
                                </h1>
                                <p class="page-subtitle">
                                    Tracked purchases and spending history
                                </p>
                            </div>
                        </div>

                        <!-- Stats and Controls -->
                        <div class="header-controls">
                            <div class="stats-badge" *ngIf="!loading">
                                <i class="fa-solid fa-receipt"></i>
                                <span>{{ totalReceipts }} total</span>
                            </div>
                            <div class="stats-badge spend-badge" *ngIf="!loading && filteredReceipts.length > 0">
                                <i class="fa-solid fa-coins"></i>
                                <span>{{ formatMoney(pageSpend(), pageCurrency()) }} this page</span>
                            </div>

                            <!-- View Toggle -->
                            <div class="view-toggle">
                                <button class="view-btn" [class.active]="viewMode === 'grid'"
                                    (click)="setViewMode('grid')" title="Grid view">
                                    <i class="fa-solid fa-grip"></i>
                                </button>
                                <button class="view-btn" [class.active]="viewMode === 'list'"
                                    (click)="setViewMode('list')" title="List view">
                                    <i class="fa-solid fa-list"></i>
                                </button>
                                <button class="view-btn" [class.active]="viewMode === 'compact'"
                                    (click)="setViewMode('compact')" title="Compact view">
                                    <i class="fa-solid fa-bars"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Server-side Filter Bar -->
                    <div class="filter-bar">
                        <div class="filter-field">
                            <label>From</label>
                            <input type="date" [(ngModel)]="startDate" class="filter-input" />
                        </div>
                        <div class="filter-field">
                            <label>To</label>
                            <input type="date" [(ngModel)]="endDate" class="filter-input" />
                        </div>
                        <div class="filter-field">
                            <label>Type</label>
                            <select [(ngModel)]="purchaseType" class="filter-input">
                                <option value="">All</option>
                                <option value="grocery">Grocery</option>
                                <option value="eating_out">Eating Out</option>
                            </select>
                        </div>
                        <button class="btn-primary apply-btn" (click)="applyFilters()">
                            <i class="fa-solid fa-filter"></i> Apply
                        </button>
                        <button class="btn-secondary" (click)="clearFilters()">
                            <i class="fa-solid fa-rotate-left"></i> Reset
                        </button>
                    </div>

                    <!-- Search + page controls -->
                    <div class="controls-bar">
                        <div class="search-box">
                            <i class="fa-solid fa-search search-icon"></i>
                            <input type="text" placeholder="Search merchant, notes, tags (this page)..."
                                [(ngModel)]="searchQuery" (input)="onSearchChange()" class="search-input" />
                            <button class="clear-search-btn" *ngIf="searchQuery" (click)="clearSearch()"
                                title="Clear search">
                                <i class="fa-solid fa-times"></i>
                            </button>
                        </div>

                        <div class="control-group">
                            <div class="items-selector">
                                <label>Show:</label>
                                <select [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()"
                                    class="select-input">
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                                    <option [value]="50">50</option>
                                    <option [value]="100">100</option>
                                </select>
                            </div>

                            <div class="sort-selector">
                                <label>Sort:</label>
                                <select [(ngModel)]="sortBy" (change)="onSortChange()" class="select-input">
                                    <option value="date-desc">Newest First</option>
                                    <option value="date-asc">Oldest First</option>
                                    <option value="total-desc">Highest Total</option>
                                    <option value="total-asc">Lowest Total</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Results Summary -->
                <div class="results-summary" *ngIf="!loading && filteredReceipts.length > 0">
                    <span>Showing {{ getStartIndex() + 1 }}-{{ getEndIndex() }} of
                        {{ totalReceipts }} receipts</span>
                </div>

                <!-- Loading State -->
                <div class="loading-container" *ngIf="loading">
                    <div class="spinner"></div>
                    <p>Loading receipts...</p>
                </div>

                <!-- Empty State -->
                <div class="empty-state" *ngIf="!loading && filteredReceipts.length === 0">
                    <div class="empty-icon">
                        <i class="fa-solid fa-receipt"></i>
                    </div>
                    <h3 class="empty-title">No receipts found</h3>
                    <p class="empty-description">
                        Try adjusting the date range or purchase type filters.
                    </p>
                    <button class="btn-primary" (click)="clearFilters()">
                        <i class="fa-solid fa-rotate-left"></i> Reset Filters
                    </button>
                </div>

                <!-- Receipts Grid/List -->
                <div class="receipts-container" [class.grid-view]="viewMode === 'grid'"
                    [class.list-view]="viewMode === 'list'" [class.compact-view]="viewMode === 'compact'"
                    *ngIf="!loading && filteredReceipts.length > 0">
                    <div class="receipt-card" *ngFor="let receipt of filteredReceipts; let i = index">
                        <!-- Card Header -->
                        <div class="card-header">
                            <div class="merchant-info">
                                <div class="merchant-name">
                                    <i class="fa-solid fa-store"></i>
                                    <span>{{ receipt?.merchantName || "Unknown merchant" }}</span>
                                </div>
                                <div class="merchant-address" *ngIf="receipt?.merchantAddress">
                                    <i class="fa-solid fa-location-dot"></i>
                                    {{ receipt.merchantAddress }}
                                </div>
                                <div class="merchant-phone" *ngIf="receipt?.merchantPhone">
                                    <i class="fa-solid fa-phone"></i>
                                    {{ receipt.merchantPhone }}
                                </div>
                            </div>
                            <div class="purchase-badges">
                                <span class="type-badge grocery" *ngIf="receipt?.isGrocery" title="Grocery">
                                    <i class="fa-solid fa-basket-shopping"></i> Grocery
                                </span>
                                <span class="type-badge dining" *ngIf="receipt?.isEatingOut" title="Eating out">
                                    <i class="fa-solid fa-utensils"></i> Dining
                                </span>
                                <span class="type-badge generic"
                                    *ngIf="!receipt?.isGrocery && !receipt?.isEatingOut && receipt?.purchaseType">
                                    {{ receipt.purchaseType }}
                                </span>
                            </div>
                        </div>

                        <!-- Total -->
                        <div class="total-row">
                            <span class="total-label">Total</span>
                            <span class="total-value">{{ formatMoney(receipt?.total, receipt?.currency) }}</span>
                        </div>

                        <!-- Amount breakdown -->
                        <div class="breakdown">
                            <div class="breakdown-item">
                                <span class="b-label">Subtotal</span>
                                <span class="b-value">{{ formatMoney(receipt?.subtotal) }}</span>
                            </div>
                            <div class="breakdown-item">
                                <span class="b-label">Tax</span>
                                <span class="b-value">{{ formatMoney(receipt?.tax) }}</span>
                            </div>
                            <div class="breakdown-item" *ngIf="receipt?.tip !== null && receipt?.tip !== undefined">
                                <span class="b-label">Tip</span>
                                <span class="b-value">{{ formatMoney(receipt?.tip) }}</span>
                            </div>
                            <div class="breakdown-item">
                                <span class="b-label">Items</span>
                                <span class="b-value">{{ receipt?.totalItems ?? "—" }}</span>
                            </div>
                        </div>

                        <!-- Notes -->
                        <div class="notes-section" *ngIf="receipt?.userNotes">
                            <i class="fa-solid fa-note-sticky"></i>
                            <span>{{ receipt.userNotes }}</span>
                        </div>

                        <!-- Tags -->
                        <div class="tags-section" *ngIf="receipt?.tags && receipt.tags.length > 0">
                            <span class="tag-chip" *ngFor="let tag of receipt.tags">
                                <i class="fa-solid fa-hashtag"></i> {{ tag }}
                            </span>
                        </div>

                        <!-- Footer -->
                        <div class="card-footer">
                            <div class="metadata-item" [title]="'Date: ' + receipt?.receiptDate">
                                <i class="fa-solid fa-calendar"></i>
                                <span class="metadata-text">{{ receipt?.receiptDate }}
                                    <ng-container *ngIf="receipt?.receiptTime">· {{ receipt.receiptTime
                                        }}</ng-container></span>
                            </div>
                            <div class="metadata-item" [title]="'Source: ' + receipt?.source">
                                <i class="fa-solid fa-tag"></i>
                                <span class="metadata-text">{{ receipt?.source || "—" }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Pagination Controls -->
                <div class="pagination-container" *ngIf="!loading && totalPages > 1">
                    <div class="pagination-info">
                        Page {{ currentPage }} of {{ totalPages }}
                    </div>

                    <div class="pagination-controls">
                        <button class="page-btn" [disabled]="currentPage === 1" (click)="goToFirstPage()"
                            title="First page">
                            <i class="fa-solid fa-angles-left"></i>
                        </button>

                        <button class="page-btn" [disabled]="currentPage === 1" (click)="previousPage()"
                            title="Previous page">
                            <i class="fa-solid fa-angle-left"></i>
                            Previous
                        </button>

                        <div class="page-numbers">
                            <button *ngFor="let page of getPageNumbers()" class="page-number-btn"
                                [class.active]="page === currentPage" [class.ellipsis]="page === -1"
                                [disabled]="page === -1" (click)="goToPage(page)">
                                {{ page === -1 ? "..." : page }}
                            </button>
                        </div>

                        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="nextPage()"
                            title="Next page">
                            Next
                            <i class="fa-solid fa-angle-right"></i>
                        </button>

                        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="goToLastPage()"
                            title="Last page">
                            <i class="fa-solid fa-angles-right"></i>
                        </button>
                    </div>

                    <div class="quick-jump">
                        <label>Go to page:</label>
                        <input type="number" [min]="1" [max]="totalPages" [(ngModel)]="jumpToPageNumber"
                            (keyup.enter)="jumpToPage()" class="page-jump-input" />
                        <button class="btn-secondary" (click)="jumpToPage()">Go</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>